export default __webpack_public_path__ + "static/media/marbled.72979d98.png";